import { connect } from 'react-redux'
import { downloadTicketsAndVouchers } from 'services/downloadFiles/reducer'
import { cancelOrder, cancelReservation, restoreToCard } from '../../reducer'

const mapStateToProps = (state) => {
    return {
        loading: state?.components.mainLoader?.loading,
    }
}

const mapDispatchToProps = { cancelReservation, cancelOrder, restoreToCard, downloadTicketsAndVouchers }

const hocOrderWindow = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocOrderWindow
